import React from "react";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import usePixModalStyles from "../PixPaymentModal.styles";
import { PixOrderInfoProps } from "../types";

const PixOrderInfo: React.FC<PixOrderInfoProps> = ({
  orderNumber,
  orderStatus,
  customerName,
  productCode,
  productName,
  volume,
  deliveryDate,
  paymentStatus,
}) => {
  const classes = usePixModalStyles();
  const isPending = paymentStatus === "pending";
  const isBlocked = orderStatus === "BLOQUEADO";

  return (
    <div
      className={`${classes.orderCard} ${
        !isPending ? classes.orderCardConfirmed : ""
      }`}
    >
      <div className={classes.orderInfo}>
        <div className={classes.orderNumber}>
          Pedido #{orderNumber}
          <span
            className={`${classes.orderStatusBadge} ${
              isBlocked
                ? classes.orderStatusBlocked
                : classes.orderStatusReleased
            }`}
          >
            {orderStatus}
          </span>
        </div>
        <p className={classes.orderCustomer}>{customerName}</p>
        <p className={classes.orderProduct}>
          {productCode} – {productName}
        </p>
        <p
          className={`${classes.orderVolume} ${
            isPending
              ? classes.orderVolumePending
              : classes.orderVolumeConfirmed
          }`}
        >
          {volume}
        </p>
      </div>

      <div className={classes.orderDateBox}>
        <div
          className={`${classes.orderDateIcon} ${
            isPending
              ? classes.orderDateIconPending
              : classes.orderDateIconConfirmed
          }`}
        >
          <CalendarTodayIcon style={{ fontSize: 16 }} />
        </div>
        <div className={classes.orderDateLabel}>Data de entrega</div>
        <div className={classes.orderDateValue}>{deliveryDate}</div>
      </div>
    </div>
  );
};

export default PixOrderInfo;
